import { createAsyncThunk, createEntityAdapter } from '@reduxjs/toolkit'
import * as Services from '../../services/endpoints'
import { Analyzer, AnalyzerBody } from '../../pages/Analyzers/types'
import { createGenericSlice, GenericState } from '../lib'

const sliceName = 'analyzers'

//todo need to reverse this and use the sate as the type
export interface AnalyzerState extends GenericState<Analyzer> {}

export const getAnalyzer = createAsyncThunk(
  `${sliceName}/getAnalyzer`,
  async (id: string, { rejectWithValue }) => {
    try {
      return await Services.getAnalyzer(id)
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (err: any) {
      return rejectWithValue(err)
    }
  }
)

export const getAllAnalyzers = createAsyncThunk(
  `${sliceName}/getAllAnalyzers`,
  async (params, { rejectWithValue }) => {
    try {
      return await Services.getAllAnalyzers()
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (err: any) {
      return rejectWithValue(err)
    }
  }
)

export const createAnalyzer = createAsyncThunk(
  `${sliceName}/createAnalyzer`,
  async (body: AnalyzerBody, { rejectWithValue }) => {
    try {
      return await Services.createAnalyzer(body)
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (err: any) {
      return rejectWithValue(err)
    }
  }
)

export const updateAnalyzer = createAsyncThunk(
  `${sliceName}/updateAnalyzer`,
  async (data: { id: string; changes: AnalyzerBody }, { rejectWithValue }) => {
    try {
      return await Services.updateAnalyzer(data)
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (err: any) {
      return rejectWithValue(err)
    }
  }
)

export const removeAnalyzer = createAsyncThunk(
  `${sliceName}/removeAnalyzer`,
  async (id: string, { rejectWithValue }) => {
    try {
      return await Services.removeAnalyzer(id)
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (err: any) {
      return rejectWithValue(err)
    }
  }
)

export const removeAnalyzerResults = createAsyncThunk(
  `${sliceName}/removeAnalyzerResults`,
  async (id: string, { rejectWithValue }) => {
    try {
      return await Services.removeAnalyzerResults(id)
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (err: any) {
      return rejectWithValue(err)
    }
  }
)

export const analyzersAdapter = createEntityAdapter()

//TODO fix type issue and replace any
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const thunkAdapters: any = [
  {
    adapterFn: (state, action) => {
      analyzersAdapter.setAll(state, [action])
    },
    thunk: getAnalyzer,
  },
  {
    adapterFn: analyzersAdapter.setAll,
    thunk: getAllAnalyzers,
  },
  {
    adapterFn: analyzersAdapter.addOne,
    thunk: createAnalyzer,
  },
  {
    adapterFn: analyzersAdapter.upsertOne,
    thunk: updateAnalyzer,
  },
  {
    adapterFn: analyzersAdapter.removeOne,
    thunk: removeAnalyzer,
  },
]

export const initialAnalyzersState: AnalyzerState = {
  ids: [],
  entities: {},
  loading: false,
  error: null,
}

export const analyzersSlice = createGenericSlice({
  name: sliceName,
  initialState: initialAnalyzersState,
  thunkAdapters,
})
